import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'underscoreToTitle',
  standalone: true,
})
export class UnderscoreToTitlePipe implements PipeTransform {

  transform(value: string): any {
    return value.split('_').map(v => v.charAt(0).toUpperCase() + v.slice(1) ).join(' ');
  }

}
